<template>
  <div class="hello">
    <span style='display:none'>版本：25.5.13.1</span>
    <div class="mask" :style="{ opacity: opacityStyle ? 1 : 0 }"></div>
    <div class="hello-text">
      <div style="display: flex; justify-content: space-between;min-width:1200px">
        <div style="display: flex;;">
        <div class="logo">
          <img
            src="../image/logobot.png"
            style="
              margin-right: 16px;
              width: 100px;
              height: 28px;
  
            "

          />

          <span class="line"></span>
          <span class="title">大模型广场</span>
        </div>

        <ul class="nav-title">
          <li :class="clickIndex == 0 ? 'bg' : ''" @click="clickNav(0,'/')">
            <svg
              t="1742960739365"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1781"
              width="20"
              height="20"
            >
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop
                    offset="0%"
                    :style="`stop-color:${
                      clickIndex == 0 ? '#fff' : '#2D57FA '
                    } ; stop-opacity: 1`"
                  />
                  <stop
                    offset="100%"
                    :style="`stop-color:${
                      clickIndex == 0 ? '#fff' : '#9F4BE3'
                    } ; stop-opacity: 1`"
                  />
                </linearGradient>
              </defs>
              <path
                d="M744.040284 124.508671L535.172275 6.133778a47.081166 47.081166 0 0 0-46.377189 0l-208.953339 118.396226c-7.167772 4.053204-13.119582 9.919684-17.258117 17.002125a46.142529 46.142529 0 0 0-6.314465 23.31659v235.960479a46.163862 46.163862 0 0 1-23.295258 40.254716l-209.614652 120.465494A46.291858 46.291858 0 0 0 0 601.82679v235.981812c0 8.191739 2.175931 16.212817 6.314465 23.31659 4.159867 7.082441 10.111678 12.948921 17.27945 17.002124l208.868009 118.460224c14.420874 8.085076 31.956315 8.085076 46.377188 0l209.891976-118.758881a47.017168 47.017168 0 0 1 46.441187 0l209.891976 118.737549c14.420874 8.106408 32.084311 8.106408 46.377188 0l208.868009-118.438892c7.189104-4.053204 13.140914-9.919684 17.300782-17.002124 4.159867-7.082441 6.357131-15.146184 6.357131-23.31659V601.82679a46.291858 46.291858 0 0 0-23.359255-40.254717l-209.614652-120.529491a46.163862 46.163862 0 0 1-23.380588-40.254717V164.763388a46.163862 46.163862 0 0 0-23.572582-40.318715v0.063998z m-181.967533 158.565613v246.733468l213.923847 122.662757a17.386112 17.386112 0 0 1 8.575727 17.36478 17.279449 17.279449 0 0 1-2.218596 6.421129l-28.500425 49.065102a17.45011 17.45011 0 0 1-17.471443 8.533062 17.556774 17.556774 0 0 1-6.463794-2.175931l-214.222505-122.876083-214.201172 122.812085a17.514108 17.514108 0 0 1-23.95657-6.378463l-28.479092-49.065103a17.300782 17.300782 0 0 1 6.335798-23.764576l214.649158-123.046744V283.010286c0-9.663692 7.786418-17.492776 17.45011-17.492776h57.043516c9.685025 0 17.535441 7.893082 17.535441 17.492776v0.063998z"
                fill="url(#gradient)"
                p-id="1782"
              ></path>
            </svg>
            <span>模型广场</span>
          </li>
          <!-- <li :class="clickIndex == 1 ? 'bg' : ''" @click="clickNav(1,'/application')" style='visibility:hidden'>
            <svg
              t="1742962158442"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1953"
              width="20"
              height="20"
            >
              <defs>
                <linearGradient
                  id="gradientt"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    :style="`stop-color:${
                      clickIndex == 1 ? '#fff' : '#1959FA'
                    } ; stop-opacity: 1`"
                  />
                  <stop
                    offset="100%"
                    :style="`stop-color:${
                      clickIndex == 1 ? '#fff' : '#04CCCA'
                    } ; stop-opacity: 1`"
                  />
                </linearGradient>
              </defs>
              <path
                d="M988.821333 353.749333l-148.629333 148.693334a120.085333 120.085333 0 0 1-169.834667 0l-148.650666-148.693334a120.149333 120.149333 0 0 1 0-169.898666l148.650666-148.672a120.106667 120.106667 0 0 1 169.813334 0l148.650666 148.693333a120.149333 120.149333 0 0 1 0 169.877333z m-658.410666 140.202667H120.021333A120.106667 120.106667 0 0 1 0 373.888V163.712a120.170667 120.170667 0 0 1 120.021333-120.32h210.133334a120.170667 120.170667 0 0 1 120.277333 120.064v210.154667a120.170667 120.170667 0 0 1-120.021333 120.32zM860.330667 1024h-210.133334a120.106667 120.106667 0 0 1-120.021333-120.064v-210.154667a120.106667 120.106667 0 0 1 120.042667-120.064h210.112a120.106667 120.106667 0 0 1 120.021333 120.064v210.154667A120.106667 120.106667 0 0 1 860.330667 1024z m-529.92 0H120.021333A120.106667 120.106667 0 0 1 0 903.936v-210.154667a120.170667 120.170667 0 0 1 120.021333-120.32h210.133334a120.106667 120.106667 0 0 1 120.021333 120.042667v210.176a119.893333 119.893333 0 0 1-73.813333 111.146667 119.765333 119.765333 0 0 1-45.952 9.173333z"
                fill="url(#gradientt)"
                p-id="1954"
              ></path>
            </svg>
            <span>应用广场</span>
          </li> -->
          <li :class="clickIndex == 2 ? 'bg' : ''" @click="clickNav(2,'/api')">
            <svg
            
              t="1742962726865"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2159"
              width="20"
              height="20"
            >
            <defs>
                <linearGradient
                  id="gradients"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    :style="`stop-color:${
                      clickIndex == 2 ? '#fff' : '#03997B'
                    } ; stop-opacity: 1`"
                  />
                  <stop
                    offset="100%"
                    :style="`stop-color:${
                      clickIndex == 2 ? '#fff' : '#09BDD9'
                    } ; stop-opacity: 1`"
                  />
                </linearGradient>
              </defs>
              <path
                d="M905.130667 84.992L522.666667 0 140.202667 84.992a46.549333 46.549333 0 0 0-36.437334 45.44v464.853333a279.253333 279.253333 0 0 0 124.373334 232.32L522.666667 1024l294.528-196.373333a279.253333 279.253333 0 0 0 124.373333-232.32V130.410667a46.549333 46.549333 0 0 0-36.437333-45.418667zM522.666667 279.274667a93.098667 93.098667 0 0 1 46.592 173.717333l-0.042667 198.634667h-93.098667v-198.656a93.077333 93.077333 0 0 1 46.549334-173.696z"
              fill="url(#gradients)"
                p-id="2160"
              ></path>
            </svg>

            <span>API密钥</span>
          </li>
        </ul>
      </div>
        <div class="right-list">
          <div v-if="group=='admin'" :style="group!='admin'?{ visibility: 'hidden'}:{}" @click="goH">
            <svg style="margin-right:5px" t="1742963175333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2334" width="16" height="16"><path d="M984.789333 810.666667H39.210667A39.253333 39.253333 0 0 1 0 771.477333V124.522667A39.232 39.232 0 0 1 39.210667 85.333333h945.578666A39.253333 39.253333 0 0 1 1024 124.522667v646.954666a39.253333 39.253333 0 0 1-39.210667 39.210667zM73.813333 736.938667h876.416V159.104H73.792v577.813333z m29.12 127.978666h818.176V938.666667H102.912v-73.770667z" fill="#666666" p-id="2335"></path></svg>
            进入管理端</div>
        
          <div  @click="goManage" v-if="username==''">
            <svg style="margin-right:5px" t="1742963250008" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2545" width="16" height="16"><path d="M874.181333 149.824c-200.128-199.765333-524.224-199.765333-724.373333 0-199.744 200.149333-199.744 524.224 0 724.373333 200.149333 199.722667 524.224 199.744 724.373333 0 199.765333-200.149333 199.765333-524.245333 0-724.373333zM248.325333 874.197333c0.064-0.725333 0.085333-1.450667 0.085334-2.176 7.594667-72.021333 38.698667-83.925333 77.162666-122.410666A261.653333 261.653333 0 0 1 512.005333 672.426667c70.378667 0 136.576 27.413333 186.410667 77.162666 34.709333 34.624 46.442667 38.890667 77.162667 122.410667 0 0.746667 0.021333 1.472 0.085333 2.197333A446.656 446.656 0 0 1 512.005333 960.213333a446.72 446.72 0 0 1-263.68-85.994666z m100.906667-432.298666c0-89.749333 73.109333-162.837333 162.858667-162.837334 89.770667 0 162.858667 73.088 162.858666 162.837334 0 89.770667-73.088 162.88-162.858666 162.88-89.749333 0-162.858667-73.088-162.858667-162.88z m487.893333 378.282666c-39.616-70.570667-44.224-69.034667-92.266666-117.013333a330.666667 330.666667 0 0 0-114.496-74.538667 220.842667 220.842667 0 0 0 102.762666-186.709333c0-122.048-98.986667-221.013333-221.013333-221.013333-122.069333 0-221.034667 98.986667-221.034667 221.013333 0 78.506667 41.002667 147.541333 102.741334 186.709333a329.088 329.088 0 0 0-114.474667 74.538667c-32.277333 32.298667-55.338667 46.442667-92.394667 117.056A447.232 447.232 0 0 1 63.792 512C64.112 264.597333 264.602667 64.106667 512.005333 63.808c247.381333 0.298667 447.893333 200.789333 448.170667 448.213333a447.168 447.168 0 0 1-123.072 308.16z" fill="#666666" p-id="2546"></path></svg>
            <span >登录</span>
          
          </div>
          <div   v-else>
            <svg style="margin-right:5px" t="1742963250008" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2545" width="16" height="16"><path d="M874.181333 149.824c-200.128-199.765333-524.224-199.765333-724.373333 0-199.744 200.149333-199.744 524.224 0 724.373333 200.149333 199.722667 524.224 199.744 724.373333 0 199.765333-200.149333 199.765333-524.245333 0-724.373333zM248.325333 874.197333c0.064-0.725333 0.085333-1.450667 0.085334-2.176 7.594667-72.021333 38.698667-83.925333 77.162666-122.410666A261.653333 261.653333 0 0 1 512.005333 672.426667c70.378667 0 136.576 27.413333 186.410667 77.162666 34.709333 34.624 46.442667 38.890667 77.162667 122.410667 0 0.746667 0.021333 1.472 0.085333 2.197333A446.656 446.656 0 0 1 512.005333 960.213333a446.72 446.72 0 0 1-263.68-85.994666z m100.906667-432.298666c0-89.749333 73.109333-162.837333 162.858667-162.837334 89.770667 0 162.858667 73.088 162.858666 162.837334 0 89.770667-73.088 162.88-162.858666 162.88-89.749333 0-162.858667-73.088-162.858667-162.88z m487.893333 378.282666c-39.616-70.570667-44.224-69.034667-92.266666-117.013333a330.666667 330.666667 0 0 0-114.496-74.538667 220.842667 220.842667 0 0 0 102.762666-186.709333c0-122.048-98.986667-221.013333-221.013333-221.013333-122.069333 0-221.034667 98.986667-221.034667 221.013333 0 78.506667 41.002667 147.541333 102.741334 186.709333a329.088 329.088 0 0 0-114.474667 74.538667c-32.277333 32.298667-55.338667 46.442667-92.394667 117.056A447.232 447.232 0 0 1 63.792 512C64.112 264.597333 264.602667 64.106667 512.005333 63.808c247.381333 0.298667 447.893333 200.789333 448.170667 448.213333a447.168 447.168 0 0 1-123.072 308.16z" fill="#666666" p-id="2546"></path></svg>
            <el-dropdown v-show="username!=''">
                <span class="el-dropdown-link">
                  {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item @click.native="goOut">个人信息</el-dropdown-item> -->
                  <el-dropdown-item @click.native="lookFun">余额/消费记录</el-dropdown-item>
                  <el-dropdown-item @click.native="lout">退出登录</el-dropdown-item>
                 
                </el-dropdown-menu>
              </el-dropdown>
     
          
          </div>
        </div>
      </div>
    </div>

<el-dialog
  title="余额 / 消费记录"
  :visible.sync="dialogVisible"
  append-to-body
  width="90%"
>
 <div>
  <h3>余额：{{count}}</h3>
  <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
      type="index"
      label="序号"
      width="50">
    </el-table-column>
    <el-table-column
        prop="model"
        label="模型"
      >
      </el-table-column>
       <el-table-column
        prop="api_key"
        label="API密钥"
      >
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="开始日期"
        width="180">
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="创建日期"
        width="180">
      </el-table-column>
      
      
      <el-table-column
        prop="total_cost"
        label="费用"
        width="180">
      </el-table-column>
   
    </el-table>
    <el-pagination
    layout="total,prev, pager, next"
    @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="yePage"
      :page-size="yelimit"

    :total="total">
  </el-pagination>
 </div>
  
</el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    // msg: String
    opacity: Boolean,
  },
  data() {
    return {
      username:'',
      routeMap: {
      '/': 0,
      '/application': 1,
      '/api': 2,
      // 添加其他路由配置
    },
      activeName: "我的课程",
      opacityStyle: false,
      clickIndex: 0,
      group:'',
      yePage:1,

      yelimit:10,
      dialogVisible:false,
      count:0,
      total:0,
      tableData: []
    };
  },
  // 添加路由监听
watch: {
  '$route'(to) {
    this.clickIndex = this.routeMap[to.path] || 0
    console.log('this.clickIndex1',to)
  }
},
  mounted() {
    console.log('this.$route',this.$route)
    this.clickIndex = this.routeMap[this.$route.path] || 0
    // console.log('this.clickIndex2',this.clickIndex)
    this.opacityStyle = this.opacity;
    console.log('this.$route.query',this.$route.query)
    if((this.$route.query && this.$route.query.token)){// 如果token存在就表示登陆了
      window.localStorage.setItem("anjing_name_token",this.$route.query.token);
      this.getInfo()
    }
    console.log('this.username',this.username)
    if(window.localStorage.getItem("anjing_name_username") && window.localStorage.getItem("anjing_name_username")!=''){
      this.username = window.localStorage.getItem("anjing_name_username");
      this.group = window.localStorage.getItem("anjing_name_group")
    }



    
  },
  watch: {
    opacity(val) {
      this.opacityStyle = val;
      console.log('this.opacityStyle1',this.opacityStyle)
    },
  },
  methods: {
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.lookFun()
      },
      handleCurrentChange(val) {
        this.lookFun()
        console.log(`当前页: ${val}`);
      },
    lookFun(){
      this.dialogVisible = true
      let data = {
        op: "accountlog",
        page:this.yePage,
        limit:this.yelimit

      };

      let _this = this;
      this.$axios 
        .post("/index.do", _this.Qs.stringify(data),{
          headers: {
    Authorization:window.localStorage.getItem("anjing_name_token") || ''
  }})
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
          _this.count= response.data.balance;
          _this.tableData = response.data.data;
          _this.total = response.data.count;
 
        
          } else {
            _this.$message.info(response.data.msg)
          
          }
        })
        .catch(function (error) {
          console.log(error);
        });

    },
    getInfo(){

      let data = {
        op: "getuser",

      };

      let _this = this;
      this.$axios 
        .post("/auth/authcontrol.do", _this.Qs.stringify(data),{
          headers: {
    Authorization:window.localStorage.getItem("anjing_name_token") || ''
  }})
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.username = response.data.data.username;
            _this.group = response.data.data.group;
            window.localStorage.setItem("anjing_name_username",response.data.data.username);
            window.localStorage.setItem("anjing_name_group",_this.group);
            window.localStorage.setItem("anjing_id_group",response.data.data._id
);
        
          } else {
            _this.$message.info(response.data.msg)
          
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    goOut(){
      // window.open('https://auth.educg.net/')
       let data = {
        op: "authpath",

      };

      let _this = this;
      this.$axios 
        .post("index.do", _this.Qs.stringify(data),{
          headers: {
    Authorization:window.localStorage.getItem("anjing_name_token") || ''
  }})
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            //  window.location.href = response.data.data
             window.open(response.data.data)
        
          } else {
          
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    goH(){
   
      window.open('https://lmp.t.educg.com/_admin/index.html#/login?redirect=%2Findex%2Fmain&token='+window.localStorage.getItem("anjing_name_token"))
      // this.$router.push({path:"/_admin/index.html",qu});
    },
    // homeGo() {
    //   if (window.location.pathname.indexOf("home") == -1) {
    //     this.$router.push("/home");
    //   }
    // },
    clickNav(index,url) {
     // 如果已经是当前路由则不操作
    //  if (this.clickIndex === index) return
    
    this.clickIndex = index
    if (url && this.$route.path !== url) {
      this.$router.push(url).catch(err => {
        if (!err.message.includes('duplicate')) {
          console.error('路由错误:', err)
        }
      })
    }
    },
    goManage(){
      console.log(90)
      let data = {
        op: "login"
    

      };

      let _this = this;
      this.$axios 
        .post("/auth/authcontrol.do", _this.Qs.stringify(data),{
          headers: {
    Authorization:window.localStorage.getItem("anjing_name_token") || ''
  }})
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
             window.location.href = response.data.data
        
          } else {
          
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    lout(){
      console.log(90)
      let data = {
        op: "logout",

      };

      let _this = this;
      this.$axios 
        .post("/auth/authcontrol.do", _this.Qs.stringify(data),{
          headers: {
    Authorization:window.localStorage.getItem("anjing_name_token") || ''
  }})
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
                // 方案1：整页刷新
            // window.location.reload()
            window.localStorage.setItem("anjing_name_username",'');
            window.localStorage.setItem("anjing_name_group",'');
            window.localStorage.setItem("anjing_name_token",'');
            _this.username=''
            _this.$router.push({ path: "/" });
              // window.location.href = "/";
              // window.location.reload()
          } else {
          
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  height: 70px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index:99

}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  background: #fff;
  box-shadow: 1px 1px 1px 1px #f1efef;

  height: 60px;
}
.hello-text {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px 20px;
  flex: 1;
  z-index: 99;
  box-sizing: border-box;
}
.line {
  width: 0;
  display: inline-block;
  height: 30px;
  margin-right: 16px;
  border-width: 1px;
  border-style: solid;
  border-color: initial;
  border-image: linear-gradient(
      180deg,
      rgba(153, 153, 153, 0),
      rgba(153, 153, 153, 0.8),
      rgba(153, 153, 153, 0)
    )
    1 / 1 / 0 stretch;
}
.title {
  font-size: 1.5rem;
  // font-size:26px;
  color: #333333;
  float: right;
  font-weight: 500;
  margin-top: -3px;
}
.logo {
  display: flex;
  margin-top: 6px;
  margin-right:100px;
  width: 325px;
}
.right-list {
  display: flex;
  // font-size: 14px;
  font-size: .85rem;
  line-height: 40px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
}
.right-list div {
  margin: 0 10px;
}
.right-list img {
  float: left;
  margin-top: 11px;
  margin-right: 3px;
}
.nav-title {
  width: 60%;
  display: flex;

  justify-content: flex-start;
  color: #333;
  font-size: 1.1rem;
  height: 40px;
  line-height: 43px;
  // font-size:18px;
}

.nav-title li {
  width: 162px;
  height: 40px;
  cursor: pointer;
  border-radius: 100px;
}
.nav-title li.bg {
  background: linear-gradient(90deg, #4386fa 0%, #9469fa 100%);
  color: #fff;
}
</style>
<style>
.hello .el-tabs__nav-wrap::after {
  background-color: transparent;
}
.hello .el-tabs__header {
  margin-bottom: 0;
}
.hello .el-tabs__item {
  height: 50px;
  color: #555555;
}
.el-tabs__item.is-active {
  color: #0079e3;
}
</style>
